import { MainMenuItem, Menu } from '@interfaces/index'
import { FETCH_MENU_FAILURE, FETCH_MENU_SUCCESS, SET_OPEN_MENU } from '../actions/menuActions'
import { FetchMenuFailure, FetchMenuRequest, FetchMenuSuccess, SetMenu } from '@actions-types/menuActionTypes'
import { homeIcon, LocalStorageItem } from '@constants/index'

export type MenuAction = FetchMenuRequest | FetchMenuSuccess | FetchMenuFailure | SetMenu
interface MenuState {
  openMenu: boolean
  data: Menu
  initialRoute: string | null
  error?: string
}

const initialState = {
  openMenu: false,
  initialRoute: null,
  data: {
    mainMenu: {
      content: [
        {
          availablePlatforms: [],
          callToActions: {
            navType: '',
            dataUrl: null,
            structureUrl: '',
            webUrl: '',
            templateId: '',
          },
          icon: '',
          id: 0,
          order: 0,
          text: '',
        },
      ],
    },
  },
  error: '',
}

const menuReducer = (state: MenuState = initialState, action: MenuAction): MenuState => {
  const menuHomeLinks = (action as FetchMenuSuccess).payload?.mainMenu?.content?.filter(
    (link: MainMenuItem) => link.icon === homeIcon,
  )
  const initialRoute = menuHomeLinks?.[0]?.callToActions?.webUrl

  switch (action.type) {
    case SET_OPEN_MENU:
      return {
        ...state,
        openMenu: (action as SetMenu).payload.openMenu,
      }
    case FETCH_MENU_SUCCESS:
      if (initialRoute) localStorage.setItem(LocalStorageItem.INITIAL_ROUTE, initialRoute)
      return {
        ...state,
        data: (action as FetchMenuSuccess).payload,
        initialRoute: initialRoute,
        error: '',
      }
    case FETCH_MENU_FAILURE:
      return { ...state, error: (action as FetchMenuFailure).payload }
    default:
      return state
  }
}

export default menuReducer
